/**
 * Classe para manipulação de datas
 */
class Datas {
    /**
     *
     * @param {Date} data Data a ser convertida
     * @param {Boolean} somenteData Se é somente a data sem a hora
     */
    static dateTimeToISO(data = new Date(), somenteData) {
        let iso = data.toISOString();
        let end = somenteData ? 10 : 19

        iso = iso.replace("T", " ").slice(0, end);
        return iso;
    }

    static formatDateLocale(date, LocaleString) {
        const data = new Date(date);
        const retorno = data.toLocaleString(LocaleString);
        return retorno.toString();
    }

    static ValidarTempoExirado(dataIni, dataFim) {
        const date1 = new Date(dataIni);
        const date2 = new Date(dataFim);
        const tempoExpiraMinuto = Math.abs(date2.getTime() - date1.getTime()) / 1000 / 60;
        return tempoExpiraMinuto;
    }

    static dataLegenda(data) {
        return new Date(data).toISOString().slice(5, 10).split("-").reverse().join("/");
    }

    /**
     * Retorna um objeto Date informando a data selecionada para o quantidade de dias atrás
     * @param {qtdeDias} qtdeDias Numebr
     */
    static dataAnterior(qtdeDias) {
        let data = new Date();
        data.setDate(data.getDate() - qtdeDias);
        return data;
    }
}
export default Datas;
